import { render } from "./CarouselComponent.vue?vue&type=template&id=553ba3fc&scoped=true"
const script = {}

import "./CarouselComponent.vue?vue&type=style&index=0&id=553ba3fc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553ba3fc"]])

export default __exports__